// Key Constants for Validation and Extraction
export const nestedExplanationKeyFull = 'توضیح_سطح_سلامت_پوست_فرد';
export const scoreKeySpace = 'امتیاز کلی سلامت پوست';
export const scoreKeyUnderscore = 'امتیاز_کلی_سلامت_پوست';
export const nestedHealthKeySpace = 'سلامت کلی پوست';
export const nestedHealthKeyUnderscore = 'سلامت_کلی_پوست';
export const scoreObjNمرهKey = 'نمره';
export const scoreObjDefinitionKey = 'تعریف'; // Using common 'تعریف'
export const scoreObjExplanationKey = 'توضیح'; // Using common 'توضیح'
export const scoreObjRecommendationKey = 'توصیه'; // Using common 'توصیه'
// Keys potentially INSIDE the nested health object (Format 2)
export const nestedHealthDefinitionKey = 'تعریف'; // Same as scoreObj
export const nestedHealthExplanationKey = 'توضیح'; // Same as scoreObj
export const nestedHealthRecommendationKey = 'توصیه نهایی'; // Specific key

export const knownTopLevelKeys = [
  'امتیاز کلی سلامت پوست', 'امتیاز_کلی_سلامت_پوست',
  'تعریف سلامت کلی پوست', 'تعریف_سلامت_کلی_پوست',
  'توضیح سطح سلامت پوست فرد', 'توضیح_سطح_سلامت_پوست_فرد',
  'توصیه نهایی', 'توصیه_نهایی',
  'توصیح سطح سلامت پوست فرد', 'توصیح_سطح_سلامت_پوست_فرد',
  'توضیح سطوح سلامت پوست فرد', 'توضیح_سطوح_سلامت_پوست_فرد',
  'توضیح سطح سلامت پوست', 'توضیح_سطح_سلامت_پوست',
  'سلامت کلی پوست', 'سلامت_کلی_پوست'
];

// --- Standardized Nested Keys (Inside score/health objects) ---
export const nestedDefinitionKey = 'تعریف';
export const nestedExplanationKey = 'توضیح';
export const nestedRecommendationKey = 'توصیه';

// --- Specific Nested Keys (Underscore Format - From SkinAnalysisPage) ---
export const nestedDefinitionKeyFull = 'تعریف_سلامت_کلی_پوست';
export const nestedRecommendationKeyFull = 'توصیه_نهایی';

// --- Specific Nested Keys (Space Format - Add these) ---
export const nestedDefinitionKeySpace = 'تعریف سلامت کلی پوست';
export const nestedExplanationKeySpace = 'توضیح سطح سلامت پوست فرد';

export const topLevelDefinitionKeySpace = 'تعریف سلامت کلی پوست';        // Defined here
export const topLevelRecommendationKeySpace = 'توصیه نهایی';          // Defined here

// --- Keys for Top-Level Extraction (Used in HomePage/SkinAnalysisPage) ---
export const topLevelExplanationKeys = [
    'توضیح سطح سلامت پوست فرد', 'توضیح_سطح_سلامت_پوست_فرد',
    'توضیح سطح سلامت پوست',
    'توضیح_سطح_سلامت_پوست',
    'توضیح سطوح سلامت پوست فرد', 'توضیح_سطوح_سلامت_پوست_فرد',
    'توضیحات', 'Explanation'
];

// --- ADD HELPER FUNCTIONS HERE ---

// Helper function for fallback logic (used by extractAnalysisFromError)
// Define it *before* extractAnalysisFromError if needed
const checkFallbackAnalysisData = (analysisData) => { // Keep local *within this file*, no export needed
  const fallbackAnalysis = analysisData?.analysis;
  if (fallbackAnalysis && typeof fallbackAnalysis === 'object') {
    const hasMetricsKey = ['تحلیل سلامت پوست', 'تحلیل معیارهای سلامت پوست', 'تحلیل پوست', 'معیارها'].some(key => fallbackAnalysis[key] !== undefined);
    // Use constants defined above in this file
    const hasScoreKey = [scoreKeySpace, scoreKeyUnderscore, 'درجه کلی سلامت پوست'].some(key => fallbackAnalysis[key] !== undefined);

    if (hasMetricsKey || hasScoreKey) {
      console.log('Fallback analysisData.analysis appears valid, using it:', fallbackAnalysis);
      return fallbackAnalysis;
    } else {
      console.warn('Fallback analysisData.analysis exists but lacks expected analysis keys:', fallbackAnalysis);
      return null;
    }
  } else {
    console.error('Fallback analysisData.analysis is not a valid object or does not exist.');
    return null;
  }
};

// Function to extract and potentially fix JSON from various formats
export const extractAnalysisFromError = (errorString, analysisData) => {
  try {
    // --- Define jsonString ---
    let processedString = String(errorString || '').trim();
    if (processedString.toLowerCase().startsWith('error')) {
        processedString = processedString.substring(5).trim();
        if (processedString.startsWith(':')) processedString = processedString.substring(1).trim();
    }
    const codeBlockMatch = processedString.match(/```(?:json)?\s*([\s\S]*?)\s*```/);
    let jsonString = codeBlockMatch ? codeBlockMatch[1].trim() : processedString; // Define jsonString here
    console.log('Raw JSON string before final processing:', jsonString);
    jsonString = jsonString.replace(/\r?\n/g, ' ').replace(/\s+/g, ' ').trim();

    // --- Check for '...' ---
    if (jsonString.includes('...')) {
      console.warn("Detected '...' in JSON string, attempting FULL regex salvage...");
      // --- Define variables for this scope ---
      let partialAnalysis = {};
      let salvagedSomething = false;
      let salvagedMetrics = [];
      const scoreRegex = /"(?:امتیاز کلی سلامت پوست|درجه کلی سلامت پوست)"\s*:\s*(\d+)/;
      const definitionRegex = new RegExp(`"${topLevelDefinitionKeySpace}"\\s*:\\s*"([^"]+)"`);
      const explanationRegex = /"توضیح سطح سلامت پوست فرد"\s*:\s*"([^"]+)"/;
      const recommendationRegex = new RegExp(`"${topLevelRecommendationKeySpace}"\\s*:\\s*"([^"]+)"`);

      const scoreMatch = jsonString.match(scoreRegex);
      const definitionMatch = jsonString.match(definitionRegex);
      const explanationMatch = jsonString.match(explanationRegex);
      const recommendationMatch = jsonString.match(recommendationRegex);

      if (definitionMatch && definitionMatch[1]) {
         partialAnalysis[topLevelDefinitionKeySpace] = definitionMatch[1];
         salvagedSomething = true; console.log('Salvaged definition.');
      }
      if (recommendationMatch && recommendationMatch[1]) {
         partialAnalysis[topLevelRecommendationKeySpace] = recommendationMatch[1];
         salvagedSomething = true; console.log('Salvaged recommendation.');
      }
      const metricObjectRegex = /\{\s*"معیار"\s*:\s*"(?:[^"\\]|\\.)*"\s*,\s*"نمره"\s*:\s*\d+\s*(?:,\s*"[^"\\]+"\s*:\s*(?:"(?:[^"\\]|\\.)*"|\d+|true|false|null)\s*)*\}/g;
      const beforeEllipsis = jsonString.substring(0, jsonString.indexOf('...'));
      let metricMatch;
      while ((metricMatch = metricObjectRegex.exec(beforeEllipsis)) !== null) {
          const metricString = metricMatch[0];
          const parsedMetric = JSON.parse(metricString);
          if (parsedMetric && typeof parsedMetric.معیار === 'string' && typeof parsedMetric.نمره === 'number') {
              console.log('(Final Salvage) Successfully parsed salvaged metric:', parsedMetric.معیار);
              salvagedMetrics.push(parsedMetric);
          }
      }

      if (salvagedSomething || salvagedMetrics.length > 0) {
        partialAnalysis['تحلیل معیارهای سلامت پوست'] = salvagedMetrics;
        console.log("Returning partially salvaged analysis object:", partialAnalysis);
        return partialAnalysis;
      } else {
        console.error("Detected '...' but failed to salvage any fields via regex.");
        return checkFallbackAnalysisData(analysisData);
      }
    }

    // --- Standard Parsing Logic ---
    console.log("No '...' detected, proceeding with standard parsing attempts.");
    const firstBrace = jsonString.indexOf('{');
    const lastBrace = jsonString.lastIndexOf('}');
    if (firstBrace === -1 || lastBrace === -1 || lastBrace <= firstBrace) {
      console.error("Could not find valid start/end braces.");
      return checkFallbackAnalysisData(analysisData);
    }
    let coreJson = jsonString.substring(firstBrace, lastBrace + 1);

    try {
      const parsed = JSON.parse(coreJson);
      console.log('Successfully parsed core JSON directly');
      return parsed;
    } catch (e1) {
      console.log('Direct parsing failed, attempting fixes:', e1.message);
      // ... (rest of the fixing attempts logic) ...
    }

    // --- Final Salvage Attempt (if standard parsing failed) ---
    console.log('Standard parsing/fixing failed. Checking for final salvage attempt...');
    if (!jsonString.includes('...')) { // Check again (though covered above, adds safety)
        console.warn("Attempting final regex metric salvage on truncated JSON (no '...').");
        let finalPartialAnalysis = {};
        let finalSalvagedSomething = false;
        let finalSalvagedMetrics = [];
        const metricObjectRegex = /\{\s*"معیار"\s*:\s*"(?:[^"\\]|\\.)*"\s*,\s*"نمره"\s*:\s*\d+\s*(?:,\s*"[^"\\]+"\s*:\s*(?:"(?:[^"\\]|\\.)*"|\d+|true|false|null)\s*)*\}/g;
        let metricMatch;
        while ((metricMatch = metricObjectRegex.exec(coreJson)) !== null) {
            try {
                const metricString = metricMatch[0];
                const parsedMetric = JSON.parse(metricString);
                if (parsedMetric && typeof parsedMetric.معیار === 'string' && typeof parsedMetric.نمره === 'number') {
                    console.log('(Final Salvage) Successfully parsed salvaged metric:', parsedMetric.معیار);
                    finalSalvagedMetrics.push(parsedMetric);
                }
            } catch (parseError) {
                console.error("Error parsing salvaged metric:", parseError);
            }
        }

        if (finalSalvagedMetrics.length > 0) {
            finalSalvagedSomething = true; // Mark salvaged if metrics found

            console.log("(Final Salvage) Attempting to salvage score/text from coreJson:", coreJson); // Log the string being searched

            // --- ALSO TRY TO SALVAGE SCORE & TOP-LEVEL TEXTS ---
            // Define regexes (using literals)
            const scoreRegex = /\"(?:امتیاز_کلی_سلامت_پوست|امتیاز کلی سلامت پوست|درجه کلی سلامت پوست)\"\s*:\s*(\d+)/;
            const definitionRegex = /\"(?:تعریف سلامت کلی پوست|تعریف_سلامت_کلی_پوست)\"\s*:\s*\"([^"]*)\"/;
            const explanationRegex = /\"(?:توضیح_سطح_سلامت_پوست_فرد|توضیح سطح سلامت پوست فرد)\"\s*:\s*\"([^"]*)\"/;
            const recommendationRegex = /\"(?:توصیه_نهایی|توصیه نهایی)\"\s*:\s*\"([^"]*)\"/;

            // Match against the ORIGINAL jsonString (before coreJson extraction)
            console.log("(Final Salvage) Matching score/text regex against ORIGINAL jsonString:", jsonString);
            const scoreMatch = jsonString.match(scoreRegex);
            const definitionMatch = jsonString.match(definitionRegex);
            const explanationMatch = jsonString.match(explanationRegex);
            const recommendationMatch = jsonString.match(recommendationRegex);

            console.log("(Final Salvage) Regex Match Results:", { scoreMatch, definitionMatch, explanationMatch, recommendationMatch }); // Log match results

            // Add salvaged score/texts to the partial analysis object
            if (scoreMatch && scoreMatch[1]) {
                // Store using a consistent key that extractScore checks
                finalPartialAnalysis[scoreKeySpace] = parseInt(scoreMatch[1], 10); // Use space key
                finalSalvagedSomething = true; console.log("(Final Salvage) Salvaged score.");
            }
            if (definitionMatch && definitionMatch[1]) {
                finalPartialAnalysis[topLevelDefinitionKeySpace] = definitionMatch[1]; // Use space key
                finalSalvagedSomething = true; console.log("(Final Salvage) Salvaged definition.");
            }
            if (explanationMatch && explanationMatch[1]) {
                // Store using a consistent key that text extraction checks
                finalPartialAnalysis[nestedExplanationKeySpace] = explanationMatch[1]; // Use the space version key
                finalSalvagedSomething = true; console.log("(Final Salvage) Salvaged explanation.");
            }
            if (recommendationMatch && recommendationMatch[1]) {
                finalPartialAnalysis[topLevelRecommendationKeySpace] = recommendationMatch[1]; // Use space key
                finalSalvagedSomething = true; console.log("(Final Salvage) Salvaged recommendation.");
            }
            // --- END ADDED SALVAGE LOGIC ---

            finalPartialAnalysis['تحلیل معیارهای سلامت پوست'] = finalSalvagedMetrics; // Add salvaged metrics
            // Return only if something (metrics OR score/text) was salvaged
            if (finalSalvagedSomething) {
               console.log("(Final Salvage) Returning partially salvaged analysis object:", finalPartialAnalysis);
               return finalPartialAnalysis;
            }
        }
    }

    console.error('Failed to parse, fix, or salvage JSON. Checking fallback.');
    return checkFallbackAnalysisData(analysisData);

  } catch (error) {
    console.error("Error in extractAnalysisFromError (outer catch):", error);
    return null;
  }
};

// --- Refined Score Extraction Helper ---
export const extractScore = (obj) => { // Added export
    // Ensure it uses constants defined above: scoreKeySpace, scoreKeyUnderscore, scoreObjNمرهKey
    console.log(`[extractScore] Checking obj:`, obj);
    console.log(`[extractScore] Object keys:`, obj ? Object.keys(obj) : 'null/undefined'); // Log keys
    if (!obj || typeof obj !== 'object') {
        // ...
        return null;
    }
    // Priority 1: Direct number value under known top-level keys
    if (typeof obj[scoreKeySpace] === 'number') return obj[scoreKeySpace];
    if (typeof obj[scoreKeyUnderscore] === 'number') return obj[scoreKeyUnderscore];
    if (typeof obj['امتیاز کلی'] === 'number') return obj['امتیاز کلی'];
    if (typeof obj['میانگین سلامت پوست'] === 'number') return obj['میانگین سلامت پوست'];
    // ...
    // Priority 2: Check inside nested score object
    const nestedScoreObjUnderscore = obj[scoreKeyUnderscore];
    const nestedScoreObjSpace = obj[scoreKeySpace];
    // ... rest of logic using scoreObjNمرهKey ...

    // Check inside nested object under scoreKeyUnderscore
    if (nestedScoreObjUnderscore && typeof nestedScoreObjUnderscore === 'object' && typeof nestedScoreObjUnderscore[scoreObjNمرهKey] === 'number') {
        console.log(`[extractScore] Found nested score under key '${scoreKeyUnderscore}' -> '${scoreObjNمرهKey}':`, nestedScoreObjUnderscore[scoreObjNمرهKey]);
        return nestedScoreObjUnderscore[scoreObjNمرهKey];
    } else if (nestedScoreObjUnderscore && typeof nestedScoreObjUnderscore === 'object' && typeof nestedScoreObjUnderscore['امتیاز'] === 'number') {
        console.log(`[extractScore] Found nested score under key '${scoreKeyUnderscore}' -> 'امتیاز':`, nestedScoreObjUnderscore['امتیاز']);
        return nestedScoreObjUnderscore['امتیاز'];
    }

    // Check inside nested object under scoreKeySpace
    if (nestedScoreObjSpace && typeof nestedScoreObjSpace === 'object' && typeof nestedScoreObjSpace[scoreObjNمرهKey] === 'number') {
        console.log(`[extractScore] Found nested score under key '${scoreKeySpace}' -> '${scoreObjNمرهKey}':`, nestedScoreObjSpace[scoreObjNمرهKey]);
        return nestedScoreObjSpace[scoreObjNمرهKey];
    } else if (nestedScoreObjSpace && typeof nestedScoreObjSpace === 'object' && typeof nestedScoreObjSpace['امتیاز'] === 'number') {
        console.log(`[extractScore] Found nested score under key '${scoreKeySpace}' -> 'امتیاز':`, nestedScoreObjSpace['امتیاز']);
        return nestedScoreObjSpace['امتیاز'];
    }

    // --- ADDED: Check inside nested object under 'امتیاز کلی' key --- 
    const nestedOverallScoreObj = obj['امتیاز کلی'];
    if (nestedOverallScoreObj && typeof nestedOverallScoreObj === 'object') {
        if (typeof nestedOverallScoreObj[scoreObjNمرهKey] === 'number') { // Check for 'نمره'
            console.log(`[extractScore] Found nested score under key 'امتیاز کلی' -> '${scoreObjNمرهKey}':`, nestedOverallScoreObj[scoreObjNمرهKey]);
            return nestedOverallScoreObj[scoreObjNمرهKey];
        } else if (typeof nestedOverallScoreObj['امتیاز'] === 'number') { // Fallback check for 'امتیاز'
            console.log(`[extractScore] Found nested score under key 'امتیاز کلی' -> 'امتیاز':`, nestedOverallScoreObj['امتیاز']);
            return nestedOverallScoreObj['امتیاز'];
        }
    }    
    // --- END ADDED CHECK ---

    // --- EXISTING: Check inside nested object under 'سلامت کلی' key ---
    const nestedHealthObj = obj['سلامت کلی'];
    if (nestedHealthObj && typeof nestedHealthObj === 'object') {
        if (typeof nestedHealthObj[scoreObjNمرهKey] === 'number') { // Check for 'نمره'
            console.log(`[extractScore] Found nested score under key 'سلامت کلی' -> '${scoreObjNمرهKey}':`, nestedHealthObj[scoreObjNمرهKey]);
            return nestedHealthObj[scoreObjNمرهKey];
        } else if (typeof nestedHealthObj['امتیاز'] === 'number') { // Fallback check for 'امتیاز'
            console.log(`[extractScore] Found nested score under key 'سلامت کلی' -> 'امتیاز':`, nestedHealthObj['امتیاز']);
            return nestedHealthObj['امتیاز'];
        }
    }

    console.log(`[extractScore] Score not found via primary methods.`);
    return null; // Not found
};

// --- Refined Text Extraction Helper ---
export const extractText = (obj, keys) => { // Added export
    if (!obj || typeof obj !== 'object') return null;
    for (const key of keys) {
        if (typeof obj[key] === 'string' && obj[key].trim()) {
            return obj[key].trim();
        }
    }
    return null;
}; 